export default "__VITE_ASSET__edeb6a27__"